import { useEffect } from 'react';

import { useRouter, NextPage } from '@eneco/next';
import Head from 'next/head';
import { signIn } from 'next-auth/react';


export const LoginPage: NextPage = () => {
  const { basePath, isReady, query } = useRouter();

  useEffect(() => {
    if (!isReady) return;

    const callbackUrl = (query?.callbackUrl as string) ?? basePath;
    signIn('okta', { callbackUrl: callbackUrl });
  }, [basePath, isReady, query]);

  return (
    <Head>
      <title>Inloggen</title>
    </Head>
  );
};
